"use client";
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useId, useRef } from 'react';
import classNames from './RadioButton4.js';

function RadioButton(props) {
    const { id, label, disabled, onChange, hasErrors = false, value, size = 'x-small', groupName, highlighted, widthFull, } = props;
    const [effect, setEffect] = useState(false);
    const inputId = useId();
    const containerRef = useRef(null);
    return (jsxs("label", { htmlFor: inputId, className: classNames.radioContainer(highlighted, widthFull), onClick: () => {
            if (!disabled) {
                onChange(id);
                setEffect(true);
            }
        }, children: [jsx("input", { id: inputId, type: "radio", className: classNames.input, checked: id === value, onChange: () => {
                    if (!disabled) {
                        onChange(id);
                        setEffect(true);
                    }
                }, onFocus: () => {
                    if (containerRef.current) {
                        containerRef.current.className = classNames.RadioButton(size, id === value, hasErrors, disabled, true);
                    }
                }, onBlur: () => {
                    if (containerRef.current) {
                        containerRef.current.className = containerRef.current.className = classNames.RadioButton(size, id === value, hasErrors, disabled, false);
                    }
                }, name: groupName }), jsxs("div", { className: classNames.labelContainer, children: [jsx("div", { className: classNames.RadioButtonWrapper(size, effect, hasErrors), onAnimationEnd: () => setEffect(false), children: jsx("label", { ref: containerRef, className: classNames.RadioButton(size, id === value, hasErrors, disabled, undefined), children: id === value && jsx("div", { className: classNames.checkIcon(size, hasErrors) }) }) }), jsx("div", { className: classNames.label(size, disabled), children: label })] })] }));
}

export { RadioButton };
